export enum Rights {
  None = 1,
  View,
  Edit,
}
